import { render, staticRenderFns } from "./SelectorWithCreate.vue?vue&type=template&id=0540e02a&"
import script from "./SelectorWithCreate.vue?vue&type=script&lang=js&"
export * from "./SelectorWithCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports